import { Box, Button, Text } from "@pingux/astro";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box
      isRow={false}
      justifyContent="center"
      alignItems="center"
      variant="cards.body"
    >
      <Text as="h1" variant="h1" color="gray-900" pb="xx">
        404... Page Not found
      </Text>
      <Button
        variant="primary"
        aria-label="Return To Home"
        onPress={() => navigate("/")}
      >
        {" "}
        Return To Home
      </Button>
    </Box>
  );
};

export default NotFound;
